import clsx from 'clsx';

import {
  ONE,
  OPS_COMPANY_MEMBER_HEADERS,
  VISIBLE_COMPANY_MEMBER_HEADERS,
} from '@/constants';
import { TableCell, TableHead, TableRow, Typography } from '@/ui';

import type {
  MembersTableSortBy,
  MembersTableSortDirection,
} from '@/store/api/userApi';

import { getSortableField } from '@/features/companyDashboard/common/members/getSortableField';

interface OpsMembersHeaderProps {
  // The body table keeps a collapsed copy that only sizes the columns; the sticky strip shows the
  // headings.
  collapsed?: boolean;
  onSort: (field: MembersTableSortBy) => void;
  sortDirection: MembersTableSortDirection;
  sortField: MembersTableSortBy;
}

const OpsMembersHeader = ({
  collapsed = false,
  onSort,
  sortDirection,
  sortField,
}: OpsMembersHeaderProps) => (
  <TableHead>
    <TableRow
      aria-hidden={collapsed || undefined}
      className={clsx({ collapse: collapsed })}
    >
      {OPS_COMPANY_MEMBER_HEADERS.map((header, index) => {
        const backendField = getSortableField(header);
        const isSortable = backendField !== null;
        const isSorted = sortField === backendField;
        const growthPlanClasses =
          header === 'Growth Plan Started' ? 'w-24 text-center' : '';

        const typographyClasses = clsx('flex items-center gap-1', {
          'justify-center': header === 'Growth Plan Started',
        });

        const nameWidthClass = header === 'Name' ? 'w-[280px]' : '';
        return (
          <TableCell
            key={`${header}-ops-company-members-table`}
            className={clsx(
              'md:table-cell',
              growthPlanClasses,
              nameWidthClass,
              {
                'cursor-pointer': isSortable,
                hidden:
                  index > VISIBLE_COMPANY_MEMBER_HEADERS &&
                  index !== OPS_COMPANY_MEMBER_HEADERS.length - ONE,
              },
            )}
            onClick={isSortable ? () => onSort(backendField) : undefined}
          >
            <Typography className={typographyClasses} variant="subtitle2">
              {header}
              {isSortable && (
                <span className="text-xs opacity-60">
                  {isSorted ? (
                    <span>{sortDirection === 'asc' ? '▲' : '▼'}</span>
                  ) : (
                    <span className="flex flex-col leading-none">
                      <span>▲</span>
                      <span>▼</span>
                    </span>
                  )}
                </span>
              )}
            </Typography>
          </TableCell>
        );
      })}
    </TableRow>
  </TableHead>
);

export default OpsMembersHeader;
